module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/t-shirts-background-bd7fe0be3b888efc99245bca24088ecc.jpg";